import { auth } from "../firebase";

async function getIdToken() {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export function apiUrl(path) {
  const base = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5000").replace(/\/$/, "");
  return path.startsWith("http") ? path : `${base}${path}`;
}

/** A signed-in GET that returns the raw file (receipts), not JSON. */
export async function apiBlob(path) {
  const token = await getIdToken();
  const res = await fetch(apiUrl(path), { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(`Couldn't open the file (${res.status})`);
  return res.blob();
}

export async function apiFetch(path, options = {}) {
  const url = apiUrl(path);

  const headers = { ...(options.headers || {}) };

  const token = await getIdToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  let body = options.body;
  if (body != null && typeof body === "object" && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }

  const res = await fetch(url, {
    ...options,
    headers,
    body,
  });

  const text = await res.text();
  let json = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {}

  if (!res.ok) {
    const err = new Error(
      (json && (json.error || json.message)) ||
        text ||
        `Request failed (${res.status})`
    );
    err.status = res.status;
    err.payload = json;
    throw err;
  }

  return json ?? null;
}
